import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AtithiNavbar from '@/components/atithi/AtithiNavbar';
import AtithiWhyChooseSection from '@/components/atithi/AtithiWhyChooseSection';
import AtithiReviewsSection from '@/components/atithi/AtithiReviewsSection';
import AtithiServicesSection from '@/components/atithi/AtithiServicesSection';
import AtithiFleetSection from '@/components/atithi/AtithiFleetSection';
import PopularRoutesSection from '@/components/seo/PopularRoutesSection';
import AtithiGallerySection from '@/components/atithi/AtithiGallerySection';
import AtithiFooter from '@/components/atithi/AtithiFooter';
import AtithiHeroSection from '@/components/atithi/AtithiHeroSection';
import AtithiAboutSection from '@/components/AtithiAboutSection';
import StickyBottomBar from '@/components/layout/StickyBottomBar';
import { useTestimonials } from '@/hooks/useTestimonials';

const scrollToBooking = () => {
  document.getElementById('booking-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const HomePage = () => {
  const location = useLocation();
  const { testimonials, loading } = useTestimonials({ active: true, limit: 6 });

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 150);
    }
  }, [location.hash]);

  return (
    <div className="page-wrapper min-h-screen bg-atithi-bg font-body pb-[52px]">
      <AtithiNavbar />

      <AtithiHeroSection />

      <section className="bg-[#F8F4EE] py-8 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-4 md:grid-cols-8 gap-4">
            {[
              { icon: '✈', label: 'Airport Transfer' },
              { icon: '→', label: 'One Way Taxi' },
              { icon: '↔', label: 'Round Trip' },
              { icon: '🏛', label: 'Tour Packages' },
              { icon: '👥', label: 'Group Travel' },
              { icon: '💼', label: 'Corporate' },
              { icon: '🌙', label: 'Night Rides' },
              { icon: '📍', label: 'City Tour' },
            ].map(({ icon, label }) => (
              <div
                key={label}
                onClick={scrollToBooking}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') scrollToBooking();
                }}
                role="button"
                tabIndex={0}
                className="flex flex-col items-center gap-2 cursor-pointer group"
              >
                <div className="w-14 h-14 rounded-2xl bg-white border-[1.5px] border-gray-100 flex items-center justify-center text-2xl shadow-sm group-hover:border-[#E8651A] group-hover:shadow-md group-hover:-translate-y-1 transition-all duration-200">
                  {icon}
                </div>
                <span className="text-[10px] text-gray-500 font-semibold text-center leading-tight group-hover:text-[#E8651A] transition-colors duration-200">
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="w-full max-w-5xl mx-auto px-8">
        <hr className="border-none h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />
      </div>

      <AtithiFleetSection />

      <PopularRoutesSection />

      <AtithiGallerySection />

      <AtithiAboutSection />

      <AtithiWhyChooseSection />
      <AtithiReviewsSection testimonials={testimonials} loading={loading} />
      <AtithiServicesSection />
      <AtithiFooter />
      <StickyBottomBar />
    </div>
  );
};

export default HomePage;
